// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"9df8f8ac","183":"fbe398da","521":"a2e5b0cf","663":"92e30d12","875":"5c806089"}[chunkId] + ".chunk.js";
};